import { useEffect } from "react"
import { useHistory, useLocation } from "react-router-dom"

const PARAM_NAME = "inviteMember"

export const useInviteMemberIntent = () => {
  const location = useLocation()
  const history = useHistory()
  const searchParams = new URLSearchParams(location.search)
  const isInviteMemberIntent = searchParams.get(PARAM_NAME) !== null

  const resetInviteMemberIntent = () => {
    searchParams.delete(PARAM_NAME)
    history.replace({
      pathname: location.pathname,
      search: searchParams.toString(),
    })
  }

  const setInviteMemberIntent = (memberId?: string) => {
    searchParams.set(PARAM_NAME, memberId || "true")
    history.replace({
      pathname: location.pathname,
      search: searchParams.toString(),
    })
  }

  return { isInviteMemberIntent, resetInviteMemberIntent, setInviteMemberIntent }
}

export const useScrollToInviteFormOnInviteMemberIntent = (formElementId: string) => {
  const { isInviteMemberIntent } = useInviteMemberIntent()

  useEffect(() => {
    if (isInviteMemberIntent) {
      const element = document.getElementById(formElementId)
      if (element) {
        element.scrollIntoView({ behavior: "smooth" })
      }
    }
  }, [isInviteMemberIntent, formElementId])

  return { isInviteMemberIntent }
}
